export default (node) => {
  /**
   * Data + elements
   */
  const cartNoteText = node.querySelector('[data-cart-note-text]');
  const closeButton = node.querySelector('[data-cart-note-close]');
  const saveButton = node.querySelector('[data-cart-note-save]');
  const noteError = node.querySelector('[data-note-error]');

  /**
   * Functions
   */

  /**
   * Open cart note
   */
  const openCartNote = async () => {
    // check if the current page is the main cart page to dont open the cart drawer
    node.classList.add('!translate-y-0');
  };

  /**
   * close cart note
   */
  const closeCartNote = () => {
    node.classList.remove('!translate-y-0');
  };

  const saveNote = async () => {
    const note = cartNoteText.value;
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        note,
      }),
    });

    if (response.ok) {
      document.dispatchEvent(
        new CustomEvent('cart-note:saved', {
          detail: {
            note,
          },
        })
      );
      closeCartNote();
    } else {
      noteError.classList.remove('hidden');
    }
  };

  /**
   * Init
   */
  const init = () => {
    closeButton.addEventListener('click', closeCartNote);

    document.addEventListener('add-note:open', openCartNote);

    saveButton.addEventListener('click', saveNote);
  };

  init();
};
